// extracted by mini-css-extract-plugin
export default {"input":"CreateUser_input__ZkMNw"};